import React, { useContext, useEffect, useState } from 'react'

import { faCalendar, faPlus } from '@fortawesome/free-solid-svg-icons'

import MonthTitle from './MonthTitle'
import { InternshipsManagerContext } from '../../../../Context/InternshipsManager/InternshipsManagerProvider'

const InstitutionMonthTitle = ({ startDate, endDate, displayAction, index }) => {
  const { dataProvider } = useContext(InternshipsManagerContext)
  const { highlightedIndexes } = useContext(dataProvider.context)
  const [isHighlighted, setIsHighlighted] = useState(false)

  useEffect(() => {
    if (typeof index !== 'undefined' && highlightedIndexes) {
      setIsHighlighted(index >= highlightedIndexes.startIndex && index <= highlightedIndexes.lastIndex)
    } else {
      setIsHighlighted(false)
    }
  }, [index, highlightedIndexes])

  return (
    <MonthTitle
      startDate={startDate}
      endDate={endDate}
      actionShown={displayAction}
      icon={displayAction ? faPlus : faCalendar}
      iconTitle={displayAction ? 'Add an internship' : 'Edit schedules'}
      index={index}
      highlighted={isHighlighted}
      onAction={() => {}}
    />
  )
}

export default InstitutionMonthTitle
